import deleteIconRed from "./delete_icon_red.png";
import deleteIcon from "./remove_icon_24px_light.png";

type DeleteIconProps = {
  color?: "light" | "red";
  onClick?: () => void;
};

const DELETE_IMAGES: Record<"light" | "red", string> = {
  light: deleteIcon,
  red: deleteIconRed,
};

export const DeleteIcon = ({ color = "light", onClick }: DeleteIconProps) => (
  <img
    src={DELETE_IMAGES[color]}
    height={20}
    alt="Delete icon"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : "default", height: "100%" }}
  />
);
